import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CANAIS = [
  {
    nome: 'Diretoria de Software e Suporte TIC',
    orgao: 'Prefeitura Municipal de Sinop — suporte técnico',
    descricao: 'Problemas de acesso à conta e erros do sistema.',
    telefone: '(66) 9242-6605',
  },
];

const ContatoPage = () => {
  const { isAuthenticated } = useAuth();
  return (
  <div className="min-h-screen bg-slate-900 text-slate-100 flex flex-col">
    <div className="flex-1 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-lg space-y-5">
        <div>
          <h1 className="text-2xl font-bold">Fale conosco</h1>
          <p className="mt-1 text-sm text-slate-400">Canais de atendimento do SIGEM</p>
        </div>

        {CANAIS.map((canal) => (
          <div key={canal.nome} className="rounded-2xl border border-white/10 bg-white/5 p-5">
            <h2 className="font-semibold">{canal.nome}</h2>
            <p className="text-xs text-slate-400">{canal.orgao}</p>
            <p className="mt-2 text-sm text-slate-300">{canal.descricao}</p>
            <a href={`tel:${canal.telefone.replace(/\D/g, '')}`} className="mt-3 inline-block text-lg font-semibold text-blue-400 hover:text-blue-300">
              {canal.telefone}
            </a>
          </div>
        ))}

        <div className="rounded-2xl border border-white/10 bg-white/5 p-5 text-sm text-slate-300">
          <p className="font-semibold text-slate-100">Ao entrar em contato, tenha em mãos</p>
          <p className="mt-1">O CNPJ e o nome da instituição, o código da emenda ou do plano de trabalho e o CPF do responsável.</p>
        </div>

        <Link to={isAuthenticated ? '/dashboard' : '/login'} className="inline-block text-sm text-blue-400 hover:text-blue-300">
          &larr; {isAuthenticated ? 'Voltar ao sistema' : 'Voltar para o login'}
        </Link>
      </div>
    </div>
  </div>
  );
};

export default ContatoPage;
